import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getBusinessType = async () => {
  return await get<ApiResponse<any[]>>("/businesstypedata").then((res) => {
    return res;
  });
};

